import { Navigate } from "react-router-dom";
import { usePermissions } from "@/contexts/PermissionsContext";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Phase G-UX (27.05.2026) — Route-level RBAC guard.
 *
 * Wraps a route element. If the current user's role has not been granted
 * `view` on the given `module`, the user is redirected to `/` (dashboard).
 * Admin and Geschäftsführung bypass the check (they always see everything,
 * just like in the sidebar nav gating).
 *
 * Usage:
 *   <Route path="abwesenheiten"
 *          element={<RequirePerm module="abwesenheiten"><Abwesenheiten /></RequirePerm>} />
 */
export default function RequirePerm({ module, action = "view", children }) {
  const { user } = useAuth();
  const { can } = usePermissions();

  // Admin / GF whitelist — same logic as sidebar adminOrGfOnly flag
  if (user?.role === "admin" || user?.is_super_admin || user?.role === "geschaeftsfuehrung") {
    return children;
  }

  if (!can(module, action)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
